/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * How much hand-work their invoicing costs us. Read from the first invoice
 * on each shipment only — later corrections are the audit's business, not a
 * measure of how the carrier bills.
 *
 * Deliberately absent: which audit rule an invoice tripped, and how any
 * problem was resolved on our side.
 *
 * @export
 * @interface PerformanceBillingHygiene
 */
export interface PerformanceBillingHygiene {
  /**
   * Shipments in the period with at least one carrier invoice.
   * @type {number}
   * @memberof PerformanceBillingHygiene
   */
  firstInvoices: number;
  /**
   * Share that arrived without a person uploading a file.
   * @type {number}
   * @memberof PerformanceBillingHygiene
   */
  electronicRate?: number;
  /**
   * Share approved without a person deciding. Pending invoices are
   * excluded from both halves — pending is not rejected.
   *
   * @type {number}
   * @memberof PerformanceBillingHygiene
   */
  autoApprovalRate?: number;
  /**
   * Share of booked shipments with a resolved audit problem attributed
   * to this carrier. Open problems are excluded: an unresolved problem
   * is something we are still testing, not something to score them on.
   *
   * @type {number}
   * @memberof PerformanceBillingHygiene
   */
  carrierFaultAuditRate?: number;
}

/**
 * Check if a given object implements the PerformanceBillingHygiene interface.
 */
export function instanceOfPerformanceBillingHygiene(
  value: object,
): value is PerformanceBillingHygiene {
  if (!("firstInvoices" in value) || value["firstInvoices"] === undefined)
    return false;
  return true;
}

export function PerformanceBillingHygieneFromJSON(
  json: any,
): PerformanceBillingHygiene {
  return PerformanceBillingHygieneFromJSONTyped(json, false);
}

export function PerformanceBillingHygieneFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceBillingHygiene {
  if (json == null) {
    return json;
  }
  return {
    firstInvoices: json["firstInvoices"],
    electronicRate:
      json["electronicRate"] == null ? undefined : json["electronicRate"],
    autoApprovalRate:
      json["autoApprovalRate"] == null ? undefined : json["autoApprovalRate"],
    carrierFaultAuditRate:
      json["carrierFaultAuditRate"] == null
        ? undefined
        : json["carrierFaultAuditRate"],
  };
}

export function PerformanceBillingHygieneToJSON(
  json: any,
): PerformanceBillingHygiene {
  return PerformanceBillingHygieneToJSONTyped(json, false);
}

export function PerformanceBillingHygieneToJSONTyped(
  value?: PerformanceBillingHygiene | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    firstInvoices: value["firstInvoices"],
    electronicRate: value["electronicRate"],
    autoApprovalRate: value["autoApprovalRate"],
    carrierFaultAuditRate: value["carrierFaultAuditRate"],
  };
}
